// extracted by mini-css-extract-plugin
export default {"newVersionGlass":"NewVersion_newVersionGlass__PIkPt","redUrl":"NewVersion_redUrl__ZLr5K"};